import { useMemo } from 'react';

import { useIntl } from 'react-intl';

import { ShortCodeEnums } from '@nhl/nhl-breakaway-ui';

type NormalizedOptions<T> = { [key in ShortCodeEnums.Language]?: T };

export const useOptionForLocale = <T>(options?: NormalizedOptions<T>, onlyUseLocaleOption?: boolean): T | undefined => {
    const intl = useIntl();

    return useMemo(() => {
        if (options === undefined) {
            return undefined;
        }

        if (options[intl.locale] !== undefined || onlyUseLocaleOption) {
            return options[intl.locale];
        }

        return options[ShortCodeEnums.Language.English];
    }, [onlyUseLocaleOption, options, intl]);
};
